import React, { useEffect } from 'react';
import { useMsal } from '@azure/msal-react';
import { useNavigate } from 'react-router-dom';
import SignInButton from './SignInButton';

const LoginPage = () => {
    const { accounts, instance, inProgress } = useMsal();
    const navigate = useNavigate();

    useEffect(() => {
        // Only navigate if we have accounts and no authentication is in progress
        if (accounts.length > 0 && inProgress === 'none') {
            instance.setActiveAccount(accounts[0]);
            navigate('/main', { replace: true });
        }
    }, [accounts, instance, navigate, inProgress]);

    return (
        <div className="login-page" style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100vh',
            backgroundImage: 'url(/assets/background.jpg)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            position: 'relative'
        }}>
            <h1 style={{ color: 'white', marginBottom: '20px' }}>SMS Gateway</h1>
            <SignInButton />
            <a href="https://coppergrey.com" target="_blank" rel="noopener noreferrer" style={{
                position: 'absolute',
                bottom: '20px',
                right: '20px'
            }}>
                <img src="https://coppergrey.com/assets/images/image01.svg" alt="Copper Grey Logo" style={{ width: '100px', height: 'auto' }} />
            </a>
        </div>
    );
};

export default LoginPage;
